import { Course } from '@yandex-int/k-common/typings';

export const getCoursesByClass = (courses: Array<Course>): Record<number, Array<Course>> => {
    return courses.reduce((acc: Record<number, Array<Course>>, course) => {
        const teams = course.teams;

        teams.forEach((team) => {
            if (acc[team]) {
                acc[team] = [...acc[team], course];
            } else {
                acc[team] = [course];
            }
        });

        return acc;
    }, {});
};
